import React, { FC } from 'react';
import styled from 'styled-components';
import { sort } from 'ramda';
import ViewRef from '@/util/ViewRef';
import SuggestedView from '@/util/SuggestedView';
import { Sticker, Tooltip } from '@trevor/ui-components';
import CategoryRef from '@/util/CategoryRef';
import { useHasSavedQueryChanged } from '@/views/QueryBuilder/hooks/useHasSavedQueryChanged';
import styles from './QueryName.module.scss';

export type QueryNameProperties = {
  onRename: F<React.MouseEvent>;
  viewBeingEdited: ViewRef | SuggestedView;
};

const TagListContainer = styled.div`
  display: inline-flex;
  gap: var(--spacing-s);
`;

type TagListProps = {
  tags: CategoryRef[];
};
const TagList: FC<TagListProps> = ({ tags }) => {
  return (
    <TagListContainer>
      {tags.map((tag) => (
        <Sticker key={tag._id} label={tag._name} />
      ))}
    </TagListContainer>
  );
};

const QueryNameContainer = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;
export const QueryName: React.FC<QueryNameProperties> = ({
  onRename,
  viewBeingEdited,
}) => {
  const savedQueryHasChanged = useHasSavedQueryChanged();
  const existingTags = sort(
    // @ts-expect-error: TODO: fix typing.
    (t1, t2) => t1._name.localeCompare(t2._name),
    // @ts-expect-error: TODO: fix typing.
    viewBeingEdited.categories,
  );

  const title = viewBeingEdited.name;

  return (
    <>
      <QueryNameContainer data-tooltip-id="fullName" onClick={onRename}>
        {title}
      </QueryNameContainer>
      <Tooltip className={styles.fullNameTooltip} id="fullName" place="bottom">
        {title}
      </Tooltip>
      {existingTags.length > 0 && <TagList tags={existingTags as any} />}
      {savedQueryHasChanged && <small>(editing)</small>}
    </>
  );
};
